module.exports = "/static-assets/_next/static/images/Poloaroid-3-c6ba44bed9f560853ba4d68e3db7add5.png";